// extracted by mini-css-extract-plugin
export var anim = "getReviewNum-module--anim--ac593";
export var ldsDualRing = "getReviewNum-module--ldsDualRing--14ea0";
export var reviews = "getReviewNum-module--reviews--6e0fd";